import type { IconData } from '@stacksjs/iconify-core'

export const heartRatePulseGraphFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M23.486 7.719c-7.475-6.572-19.4-2.552-21.56 7.19c-1.491 6.347 1.033 11.768 4.757 16.202c3.696 4.4 8.741 8.035 12.715 10.897l.027.02a7.84 7.84 0 0 0 9.149 0l.027-.02c3.974-2.862 9.019-6.497 12.715-10.897c3.724-4.434 6.248-9.855 4.757-16.201c-2.16-9.743-14.086-13.763-21.56-7.191c-.174.151-.346.314-.514.48c-.167-.166-.34-.329-.513-.48\"/><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M29.94 12a2 2 0 0 1 1.888 1.188L35.3 21H39a2 2 0 1 1 0 4h-5a2 2 0 0 1-1.828-1.188l-2.015-4.535l-4.284 11.425a2 2 0 0 1-3.715.077l-3.943-9.32l-1.487 2.549A2 2 0 0 1 15 25H9a2 2 0 1 1 0-4h4.851l2.921-5.008a2 2 0 0 1 3.57.229l3.546 8.381l4.24-11.304A2 2 0 0 1 29.94 12\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default heartRatePulseGraphFlat
